module.exports = __webpack_public_path__ + "static/shoe-with-model-3a7749610ec7a29e551f9b795df27381.jpg";